import { registerBlockCollection } from '@wordpress/blocks'

/**
 * @link https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
registerBlockCollection('usna1978', { title: 'USNA 1978' })
